import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

// Components
import DownloadIcon from '../DownloadIcon';

// Store
import {
  $levelList,
  $levelSelected,
  $surveyList,
  $surveySelected,
  LEVEL_ALL,
  LevelSelectedType,
  setIndicatorSelected,
  setLevelSelected,
  setSurveySelected,
} from '../../store/slices/admin2EstimatesSlice';
import { $toolSelected } from '../../store/slices/admin2ToolsSlice';

//Configs
import { INDICATORS } from '../../configs/indicators.config';
import { TOOLS_OPTIONS_OBJECT } from '../../configs/tools.configs';

// Styles
import './Admin2Filters.scss';

function Admin2Filters() {
  const dispatch = useDispatch();
  const surveyList = useSelector($surveyList);
  const surveySelected = useSelector($surveySelected);
  const levelList = useSelector($levelList);
  const levelSelected = useSelector($levelSelected);
  const toolSelected = useSelector($toolSelected);

  const handleSurveyChange = (event: any, child: any) => {
    const survey = child?.props['data-survey'];
    dispatch(setSurveySelected(survey));
    dispatch(setLevelSelected(LEVEL_ALL));
  };

  const handleLevelChange = (event: any, element: any) => {
    const data = element.props['data-tag'];
    dispatch(setLevelSelected(data));
  };

  const handleIndicatorChange = (event: any, child: any) => {
    const indicator = child?.props['data-indicator'];
    dispatch(setIndicatorSelected(indicator));
  };

  return (
    <section className='row admin-2-estimates__filters-container'>
      <div className='col-lg-3 col-md-3 admin-2-estimates__filter-section'>
        <div className='admin-2-estimates__filter-section--title'>
          <h4>Select a Survey</h4>
        </div>
        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>Survey</InputLabel>
          {surveyList && (
            <Select
              labelId='demo-simple-select-label'
              id='demo-simple-select'
              label='Survey'
              defaultValue={surveyList[0].value}
              // TODO: remove at cleanup stage - defaultValue={INITIAL_SURVEY_SELECTED.value}
              onChange={handleSurveyChange}
            >
              {surveyList.map((survey: any, index: number) => {
                const { value } = survey;

                return (
                  <MenuItem key={`country_Survey_${index}`} data-survey={survey} value={value}>
                    {value}
                  </MenuItem>
                );
              })}
            </Select>
          )}
        </FormControl>
      </div>

      <div className='col-lg-3 col-md-3 admin-2-estimates__filter-section'>
        <div className='admin-2-estimates__filter-section--title'>
          <h4>Select a Level</h4>
        </div>
        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>Level</InputLabel>
          {levelList && (
            <Select
              labelId='demo-simple-select-label'
              id='demo-simple-select'
              label='Level'
              value={levelSelected.level}
              onChange={handleLevelChange}
              disabled={toolSelected !== TOOLS_OPTIONS_OBJECT.map.label}
            >
              {levelList.map((levelItem: LevelSelectedType, index: number) => {
                const { level } = levelItem;

                return (
                  <MenuItem key={`region_Level_${index}`} value={levelItem.level} data-tag={levelItem}>
                    {level}
                  </MenuItem>
                );
              })}
            </Select>
          )}
        </FormControl>
      </div>

      <div className='col-lg-3 col-md-3 admin-2-estimates__filter-section'>
        <div className='admin-2-estimates__filter-section--title'>
          <h4>Select an Indicator</h4>
        </div>
        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>Indicator</InputLabel>
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            label='Indicator'
            defaultValue={INDICATORS[0].value}
            onChange={handleIndicatorChange}
          >
            {INDICATORS.map((indicator: any) => {
              const { label, value } = indicator;

              return (
                <MenuItem key={value} data-indicator={indicator} value={value}>
                  {label}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </div>

      <div className='col-lg-3 col-md-3 admin-2-estimates__download'>
        <a className='download-button' href={surveySelected?.downloadPackageFromS3Link}>
          DOWNLOAD <DownloadIcon color={'#fff'} />
        </a>
      </div>
    </section>
  );
}

export default Admin2Filters;
